module.exports = __webpack_public_path__ + "img/total-posts.d505ee3a.svg";